// RadioGroup.tsx
import { Radio } from "antd";
import styles from "./style.module.scss";
import { useEffect, useState } from "react";

interface RadioGroupProps {
  options: { value: string; label: string }[];
  onChange?: (value: string) => void;
  defaultValue?: string;
}

export default function RadioGroup({
  options,
  onChange,
  defaultValue,
}: RadioGroupProps) {
  const [value, setValue] = useState<string | undefined>(defaultValue);

  useEffect(() => {
    setValue(defaultValue);
  }, [defaultValue]);

  const handleClick = (e: React.MouseEvent<HTMLInputElement>) => {
    const clickedValue = e.currentTarget.value;
    setValue(clickedValue);
    onChange && onChange(e.currentTarget.value);
  };
  return (
    <div className={styles.radioGroup}>
      <Radio.Group value={value} defaultValue={defaultValue}>
        {options?.map((option) => (
          <Radio
            className={styles.radioButton}
            value={option.value}
            onClick={handleClick}
          >
            <div className={styles.label}>{option.label}</div>
          </Radio>
        ))}
      </Radio.Group>
    </div>
  );
}
